import { CommonResponse, get } from './common.ts'

/**
 * (01)
 * 학교 목록 조회
 */

// GET /schools
interface GetSchoolsResponse {
  id: string
  name: string
  educationLevel: string
}

export const getSchools = async (): Promise<CommonResponse<GetSchoolsResponse>> => {
  return await get('/schools')
}

/**
 * (02)
 * 학기 조회
 */

// GET /schools/semester
interface GetSchoolsSemesterResponse {
  nowSemester: {
    id: string
    name: string
    startDate: number
    endDate: number
    schoolId: string
  }
  semesters: {
    id: string
    name: string
    startDate: number
    endDate: number
    schoolId: string
  }[]
}

export const getSchoolsSemester = async (): Promise<CommonResponse<GetSchoolsSemesterResponse>> => {
  return await get('/schools/semester')
}

/**
 * (03)
 * 학기별 반 조회
 */

// GET /schools/{semesterId}/class
interface GetSchoolsClassRequest {
  semesterId: string
}
interface GetSchoolsClassResponse {}

export const getSchoolsClass = async (
  request: GetSchoolsClassRequest,
): Promise<CommonResponse<GetSchoolsClassResponse>> => {
  return await get(`/schools/${request.semesterId}/class`)
}

/**
 * (04)
 * 전공 그룹 조회
 */

// GET /schools/major-group
interface GetSchoolsMajorGroupResponse {}

export const getSchoolsMajorGroup = async (): Promise<
  CommonResponse<GetSchoolsMajorGroupResponse>
> => {
  return await get('/schools/major-group')
}

/**
 * (05)
 * 학년 조회
 */

// GET /schools/grade
interface GetSchoolsGradeResponse {}

export const getSchoolsGrade = async (): Promise<CommonResponse<GetSchoolsGradeResponse>> => {
  return await get('/schools/grade')
}
